import React from "react"

export const ItalicSymbol = props => (
	<svg viewBox="0 0 18 18" {...props}>
		<path className="ql-stroke" d="M7 4h6M5 14h6M8 14l2-10" />
	</svg>
)
